import React from 'react';

const COLORS = {
  navy: '#1E293B',
  green: '#16A34A',
  gray: '#64748B',
  grayL: '#94A3B8',
  border: '#E2E8F0',
  greenL: '#F0FDF4',
  greenMid: '#BBF7D0',
};

export default function PrivacyPage() {
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
      background: '#F8FAFC',
      minHeight: '100vh',
    }}>
      {/* Navbar */}
      <nav style={{
        background: COLORS.green,
        padding: '14px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}>
        <div style={{
          width: 32, height: 32,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <svg width="18" height="18"
               viewBox="0 0 20 20" fill="none">
            <path d="M10 2L11.8 7.2H17.6
              L12.8 10.4L14.6 15.6L10 12.4
              L5.4 15.6L7.2 10.4L2.4 7.2
              H8.2L10 2Z" fill="white"/>
          </svg>
        </div>
        <span style={{
          color: 'white',
          fontSize: 16,
          fontWeight: 700,
        }}>SuperFit Family</span>
        <a href="/"
           style={{
             marginLeft: 'auto',
             color: 'rgba(255,255,255,0.8)',
             fontSize: 13,
             textDecoration: 'none',
           }}>
          ← Back to home
        </a>
      </nav>

      {/* Content */}
      <div style={{
        maxWidth: 680,
        margin: '0 auto',
        padding: '48px 24px 80px',
      }}>
        <h1 style={{
          fontSize: 32,
          fontWeight: 800,
          color: COLORS.navy,
          marginBottom: 8,
        }}>Privacy Policy</h1>

        <p style={{
          fontSize: 13,
          color: COLORS.grayL,
          marginBottom: 40,
        }}>Last updated: April 2026</p>

        <div style={{
          background: COLORS.greenL,
          border: `0.5px solid ${COLORS.greenMid}`,
          borderRadius: 12,
          padding: '16px 20px',
          marginBottom: 32,
          fontSize: 14,
          color: '#14532D',
          lineHeight: 1.7,
          fontWeight: 600,
        }}>
          SuperFit Family is built for Indian
          families. We take the privacy of your
          family — especially your children —
          seriously.
        </div>

        {[
          {
            title: 'What we collect',
            content: `We collect only what is necessary to run the app: family name, parent name, children names and ages, daily habit completion records, money jar balances (points only — not real money), and your email address if you join our waitlist. We also collect your device timezone to reset habits at midnight in your local time.`,
          },
          {
            title: 'What we never do',
            content: `We never sell your data to anyone. We never share your data with advertisers. We never show ads inside the app. We never use your children's data for any purpose other than running the app for your family. We never track your location. We never access your contacts, camera, or microphone.`,
          },
          {
            title: "Children's privacy",
            content: `SuperFit Family is designed for families with children aged 2–14. All child data is accessible only to the parent account holder. No child data is ever shared with any third party. Children cannot create accounts independently — all accounts are created and controlled by parents. We do not knowingly collect personal information from children without verifiable parental consent.`,
          },
          {
            title: 'Data storage',
            content: `All data is stored on servers in India (Mumbai region). Your family's data never leaves India. Data is encrypted in transit using HTTPS and at rest using industry-standard encryption. We use Railway (India region) for backend hosting.`,
          },
          {
            title: 'Push notifications',
            content: `If you enable daily reminders, we send one notification per day at the time you choose. You can disable this at any time from the Settings screen in the app. We never send more than one notification per day.`,
          },
          {
            title: 'Third-party services',
            content: `We use Railway for backend hosting (India region), Vercel for web app hosting, and Formspree for waitlist email collection. We do not use Google Analytics, Facebook Pixel, or any advertising technology of any kind.`,
          },
          {
            title: 'Deleting your data',
            content: `You can delete your family account and all associated data from the Settings screen in the app. Deletion is immediate and permanent. We retain no backups of deleted accounts after 30 days.`,
          },
          {
            title: 'Changes to this policy',
            content: `If we make significant changes to this privacy policy, we will notify you via the app before the changes take effect. The date at the top of this page shows when it was last updated.`,
          },
          {
            title: 'Contact us',
            content: `Questions about privacy? Reach us via the contact form at superfitfamily.in — scroll to the bottom and use the waitlist form with subject "Privacy Question".`,
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: 32 }}>
            <h2 style={{
              fontSize: 18,
              fontWeight: 700,
              color: COLORS.navy,
              marginBottom: 10,
            }}>{section.title}</h2>
            <p style={{
              fontSize: 15,
              color: COLORS.gray,
              lineHeight: 1.8,
              margin: 0,
            }}>{section.content}</p>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{
        borderTop: `0.5px solid ${COLORS.border}`,
        padding: '24px',
        textAlign: 'center',
        fontSize: 13,
        color: COLORS.grayL,
      }}>
        <div style={{ marginBottom: 8 }}>
          SuperFit Family · Built for Indian families
        </div>
        <div style={{ display: 'flex', gap: 20,
          justifyContent: 'center' }}>
          <a href="/"
             style={{ color: COLORS.green,
               textDecoration: 'none' }}>
            Home
          </a>
          <a href="https://app.superfitfamily.in"
             target="_blank" rel="noreferrer"
             style={{ color: COLORS.green,
               textDecoration: 'none' }}>
            Open App
          </a>
        </div>
      </div>
    </div>
  );
}
